import { CustomerStatusType } from '../types/customerStatusType';

interface GetAllowedCustomerStatusToCreateOrderParams {
  allowBlockedCustomerToCreateOrder?: boolean;
}

const ALL_CUSTOMER_STATUS = Object.values(CustomerStatusType);

export const getAllowedCustomerStatusToCreateOrder = ({
  allowBlockedCustomerToCreateOrder = false,
}: GetAllowedCustomerStatusToCreateOrderParams): CustomerStatusType[] => {
  const notAllowedStatusToCreate = [
    CustomerStatusType.INACTIVE,
    ...(!allowBlockedCustomerToCreateOrder ? [CustomerStatusType.BLOCKED] : []),
  ];

  return ALL_CUSTOMER_STATUS.filter((status) => !notAllowedStatusToCreate.includes(status));
};
